<template>
  <!-- 易宝收款通道 -->
  <div ref="registrInfoRef">
    <!-- 线下收款 -->
    <div class="manage-card-box">
      <div v-if="offlinePayStatus?.status != EOfflineReceiptStatus.AUTHORIZE_STATE_AUTHORIZED" class="info-card-title flex items-center border-b border-[#ebeef5] pb-[20px]">
        线下收款
        <span v-if="showWeChatAuth||showAliPayAuth" class="pl-[24px] pr-[24px] font-normal text-sm">微信认证
          <el-tag v-if="showWeChatAuth" type="primary" class="mr-2">待认证</el-tag>
          <el-tag v-else type="success" class="mr-2">已认证</el-tag>
          <el-button v-if="showWeChatAuth" v-permission="['yop:offline:account:add']" type="primary" size="small" @click="toAuth(1)">
            去认证
          </el-button>
        </span>
        <span v-if="showWeChatAuth||showAliPayAuth" class="pl-[24px] pr-[24px] font-normal text-sm">支付宝认证
          <el-tag v-if="showAliPayAuth" type="primary" class="mr-2">待认证</el-tag>
          <el-tag v-else type="success" class="mr-2">已认证</el-tag>
          <el-button v-if="showAliPayAuth" v-permission="['yop:offline:account:add']" type="primary" size="small" @click="toAuth(2)">
            去认证
          </el-button>
        </span>
        <el-button v-if="showApply" v-permission="['yop:offline:account:add']" class="ml-auto" type="primary" :loading="saving" @click="applyOfflinePayment">
          {{ applyFailed ? '重新' : '' }}申请
        </el-button>
      </div>
      <div v-else class="flex flex-col mb-3">
        <div class="info-card-title flex items-center  mb-3">
          线下收款
          <span class="pl-[24px] pr-[24px] font-normal text-sm">微信认证
            <el-tag type="success" class="mr-2">已认证</el-tag>
          </span>
          <span class="pl-[24px] pr-[24px] font-normal text-sm">支付宝认证
            <el-tag type="success" class="mr-2">已认证</el-tag>
          </span>
        </div>
        <div class="font-normal !text-[#95A0B6] border-b border-[#ebeef5] pb-6">
          微信、支付宝、云闪付
        </div>
      </div>
      <div class="base-info-list">
        <div v-if="offlinePayStatus?.status == EOfflineReceiptStatus.AUTHORIZE_STATE_AUTHORIZED" class="flex">
          <img src="@core/main/assets/images/yibao/offline-payment-wechat.png" alt="" class="mr-3 w-[140px] h-[140px]">
          <img src="@core/main/assets/images/yibao/offline-payment-alipay.png" alt="" class="mr-3 w-[140px] h-[140px]">
          <img src="@core/main/assets/images/yibao/offline-payment-cloud.png" alt="" class="w-[140px] h-[140px]">
        </div>
        <div v-else class="wallet-status">
          <svg-icon :icon="offlinePayStatus.icon" :style="`color: ${offlinePayStatus.iconColor}`" />
          <div class="wallet-desc">
            {{ offlinePayStatus.description }}
          </div>
          <div v-if="offlinePayStatus?.errorReason" class="wallet-error">
            失败原因：{{ offlinePayStatus?.errorReason }}
          </div>
        </div>
      </div>
    </div>

    <!-- 大额支付 -->
    <div class="manage-card-box my-5">
      <div class="info-card-title flex items-center border-b border-[#ebeef5] pb-[20px]">
        大额支付
        <span class="pl-[24px] pr-[24px] font-normal !text-[#95a0b6] text-sm">状态：
          <el-tag :type="largePaymentStatus.color">{{ largePaymentStatus.label }}</el-tag>
        </span>
        <el-popover
          placement="bottom-start"
          width="270"
          trigger="hover"
          content="请联系客户经理线下提供资料进行开通"
        >
          <template #reference>
            <el-button v-if="largePaymentStatus.status == EAccountBookStatus.NOTAPPLY" class="ml-auto" type="primary" disabled>
              申请
            </el-button>
          </template>
        </el-popover>
      </div>
      <div>
        <div v-if="largePaymentStatus.status == EAccountBookStatus.SUCCESS" class="base-info-list">
          <div class="left-list gap-y-[14px]">
            <div class="item">
              <div class="label">
                收款人户名
              </div>
              <div class="value">
                {{ data.name }}
              </div>
            </div>
            <div class="item">
              <div class="label">
                开户银行
              </div>
              <div class="value">
                支付机构备付金集中存款账户
              </div>
            </div>
            <div class="item">
              <div class="label">
                开户地/省市
              </div>
              <div class="value">
                北京市
              </div>
            </div>
          </div>
          <div class="right-list">
            <div class="item">
              <div class="label">
                收款账号
              </div>
              <div class="value">
                {{ data.accountBooks?.[0].ypAccountBookNo || '-' }}
              </div>
            </div>
            <div class="item">
              <div class="label">
                分支行/网点
              </div>
              <div class="value">
                选择易宝支付-备付金账户
              </div>
            </div>
          </div>
        </div>
        <div v-else class="wallet-status">
          <svg-icon :icon="largePaymentStatus.icon" :style="`color: ${largePaymentStatus.iconColor}`" />
          <div class="wallet-desc">
            {{ largePaymentStatus.description }}
          </div>
        </div>
      </div>
    </div>

    <!-- 微信、支付宝认证弹窗-->
    <el-dialog
      v-model="dialogVisible"
      title=""
      width="400"
    >
      <div id="qrcode" style="padding: 30px 0;background-color: #fff;border-radius: 30px;">
        <div class="flex items-center justify-center ">
          <img v-if="showAuthType==2" class="flex-1 h-auto w-1/3" :src="alipay" alt="yibao">
          <img v-if="showAuthType==1" class="flex-1 h-auto w-1/3 mx-[16px]" :src="wechatPay" alt="wechat">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType, ref } from 'vue';
import { SvgIcon } from '@vue3/components';
import { IYibaoDetail, EAccountBookStatus } from '../../../../types/yibao';
import { ElMessage } from 'element-plus';
import { submitOfflineReceipt, useYibaoPaymentChannelStatus } from '@core/main';
import { EOfflineReceiptStatus } from '../../../../types/common';
import wechatPay from '@core/main/assets/images/pay/offline-wechat-pay.png';
import alipay from '@core/main/assets/images/pay/offline-alipay.png';
import { useRoute } from 'vue-router';
import { isNull } from '@core/tools';

const props = defineProps({
  data: {
    type: Object as PropType<IYibaoDetail>,
    default() {
      return {} as IYibaoDetail;
    },
  },
});

defineOptions({ name: 'YibaoPaymentChannel' });

const emit = defineEmits(['reload']);

const registrInfoRef = ref<HTMLDivElement>();
const dialogVisible = ref(false);
const info = ref(props.data);
const showAuthType = ref(0);
const { offlinePayStatus, largePaymentStatus } = useYibaoPaymentChannelStatus(info);
const route = useRoute();
const yibaoId = computed(() => Number(route.query.yibaoId));

const saving = ref(false);
let lock = false;

const unApply = computed(() => isNull(props.data.offlineReceiptStatus) || [EOfflineReceiptStatus.PENDING_SUBMIT, EOfflineReceiptStatus.DRAFT].includes(props.data.offlineReceiptStatus));
const applyFailed = computed(() => props.data.offlineReceiptStatus === EOfflineReceiptStatus.PRODUCT_MODIFY_REVIEW_BACK);
const showApply = computed(() => unApply.value || applyFailed.value);
const showWeChatAuth = computed(() => [
  EOfflineReceiptStatus.PRODUCT_MODIFY_COMPLETED,
  EOfflineReceiptStatus.AUTHORIZE_STATE_UNAUTHORIZED,
  EOfflineReceiptStatus.AUTHORIZE_STATE_ALIPAY_AUTHORIZED,
].includes(info.value.offlineReceiptStatus));
const showAliPayAuth = computed(() => [
  EOfflineReceiptStatus.PRODUCT_MODIFY_COMPLETED,
  EOfflineReceiptStatus.AUTHORIZE_STATE_UNAUTHORIZED,
  EOfflineReceiptStatus.AUTHORIZE_STATE_WECHAT_AUTHORIZED,
].includes(info.value.offlineReceiptStatus));

async function applyOfflinePayment() {
  if (saving.value || lock || !yibaoId.value) return;

  saving.value = true;
  lock = true;
  try {
    await submitOfflineReceipt(yibaoId.value);

    ElMessage.success('已提交，请耐心等待审核');

    setTimeout(() => {
      emit('reload');
    }, 1500);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  saving.value = false;
  setTimeout(() => {
    lock = false;
  }, 600);
}

async function toAuth(type) {
  showAuthType.value = type;
  dialogVisible.value = true;
}

</script>

<style lang="scss" scoped>
.wallet-status {
  width: 100%;
  @apply flex flex-col items-center justify-center h-[164px] text-[#344767];

  .svg-icon {
    @apply h-[44px] w-[44px];
  }
}
</style>